import { useEffect, useRef } from 'react';

import { SECTION_KEYS, SectionKey } from './types';

type UseSectionScrollSpyProps = {
  onActiveChange: (section: SectionKey) => void;
};

export const useSectionScrollSpy = ({ onActiveChange }: UseSectionScrollSpyProps) => {
  const onActiveChangeRef = useRef(onActiveChange);

  useEffect(() => {
    onActiveChangeRef.current = onActiveChange;
  });

  useEffect(() => {
    const entries = new Map<string, IntersectionObserverEntry>();

    const pickMostVisible = () => {
      let best: string | null = null;
      let bestRatio = -1;

      for (const [id, entry] of entries) {
        if (entry.intersectionRatio > bestRatio) {
          bestRatio = entry.intersectionRatio;
          best = id;
        }
      }
      if (best && SECTION_KEYS.includes(best as SectionKey)) {
        onActiveChangeRef.current(best as SectionKey);
      }
    };

    const observer = new IntersectionObserver(
      (ioEntries) => {
        for (const entry of ioEntries) {
          entries.set(entry.target.id.replace('section-', ''), entry);
        }
        pickMostVisible();
      },
      { root: null, threshold: [0, 0.25, 0.5, 0.75, 1] }
    );

    for (const key of SECTION_KEYS) {
      const el = document.querySelector(`#section-${key}`);

      if (el) {
        observer.observe(el);
      }
    }

    return () => observer.disconnect();
  }, []);
};
